import { render, staticRenderFns } from "./historico-puestos.vue?vue&type=template&id=10821f1c&lang=html"
import script from "./historico-puestos.vue?vue&type=script&lang=js"
export * from "./historico-puestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports